import React, { HTMLProps } from 'react';
import { SportNavFiltersContent } from 'features/sport/components/sportNav/sportNavFilters/sportNavFiltersContent';
import { SportNavFiltersHeader } from 'features/sport/components/sportNav/sportNavFilters/sportNavFiltersHeader';
import styles from './SportNavFilters.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';
import classNames from 'classnames';

export type SportNavFiltersProps = {
  // filters: Filtri;
  visibility: boolean;
  handleClose: React.Dispatch<React.SetStateAction<boolean>>;
} & HTMLProps<HTMLElement>;

export const SportNavFilters = ({ visibility, className, handleClose }: SportNavFiltersProps) => {
  const filterLabel = useGetLabelByKey('prematch-filters-title')!;
  return (
    <div className={classNames(className ?? styles.container, visibility ? styles.visible : styles.hidden)}>
      <SportNavFiltersHeader label={filterLabel} handleClose={handleClose} />
      <SportNavFiltersContent handleClose={handleClose} />
    </div>
  );
};